import { ErrorModel } from '../interfaces/states';
import * as constants from "../constants";
import { AuthResponseModel } from '../interfaces/models';
import { AuthActions } from '../interfaces/actions';

/**
 * Action creator to set authentication data in Redux store
 * Ensures consistent authentication state tracking
 * 
 * @param auth - Authentication response data
 * @returns Redux action
 */
export function receiveAuth(auth: AuthResponseModel): AuthActions {
    // Add explicit isAuthenticated flag to help with consistent state tracking
    const enhancedAuth: AuthResponseModel = {
        ...auth,
        isAuthenticated: !!auth.identityToken
    };
    
    return { 
        type: constants.RECEIVE_AUTH_USER, 
        auth: enhancedAuth 
    };
}

/**
 * Action creator to log authentication errors
 * 
 * @param error - Error information
 * @returns Redux action
 */
export function logAuthError(error: ErrorModel): AuthActions {
    return { 
        type: constants.LOG_AUTH_ERROR, 
        error 
    };
}

/**
 * Action creator to handle user signout
 * No additional data needed for signout
 * 
 * @returns Redux action
 */
export function signoutUser(): AuthActions {
    return { 
        type: constants.SIGNOUT_USER 
    };
}

/**
 * Action creator to clear auth-related data after signout
 * Use this after the signout action for complete cleanup
 * 
 * @returns Redux action
 */
export function clearAuthData(): AuthActions {
    return {
        type: constants.CLEAR_AUTH_DATA
    };
}

export type authActions = AuthActions;